<template>
  <div>
    <!-- 课程未购买只能试看时，is_hover为false -->
    <dl :class="{ 'chapter_list': true, 'is_hover': canStudy }" v-for="(ch, index) in chapter_data">
      <dt v-if="chapter_data.length > 1 || ch.introduction" @click="ch.showIntro = !ch.showIntro">
        <span>{{ ch.title }}</span>
        <van-icon name="arrow-down" v-if="ch.introduction && !ch.showIntro" />
        <van-icon name="arrow-up" v-if="ch.introduction && ch.showIntro" />
      </dt>
      <div v-if="ch.introduction" v-show="ch.showIntro" class="intro ueditor_content ueditor_style" v-html="ch.introduction"></div>
      <dd v-for="(item, i) in ch.chapter_content" @click="goStudyHandler(item)">
        <div class="top" v-if="item.face_uuid">
          <i class="iconfont icon-qqq_huaban1"></i>
          <span class="title">{{ index+1 }}.{{ i+1 }} {{ item.face_teaching.name }}</span>
        </div>
        <div class="top" v-else-if="item.live_uuid">
          <i class="iconfont icon-qqq-02"></i>
          <span class="title">{{ index+1 }}.{{ i+1 }} {{ item.live.name }}</span>
        </div>
        <div class="top" v-else-if="item.video_uuid">
          <i class="iconfont icon-qqq-03"></i>
          <span class="title">{{ index+1 }}.{{ i+1 }} {{ item.video.name }}</span>
        </div>
        <div class="top" v-else-if="item.authentication_uuid">
          <i class="iconfont icon-tubiaocankaoxian1024-05"></i>
          <span class="title">{{ index+1 }}.{{ i+1 }} {{ item.authentication.name }}</span>
        </div>
        <div class="top" v-else-if="item.experiment_uuid">
          <i class="iconfont icon-tubiaocankaoxian1024-04-copy-copy"></i>
          <span class="title">{{ index+1 }}.{{ i+1 }} {{ item.experiment.course_name }}</span>
        </div>
        <div class="bottom">
          <div class="left" v-if="item.face_uuid">（{{ item.city }} · {{ item.start_at }}&nbsp;-&nbsp;{{ item.end_at }}）</div>
          <div class="left" v-else-if="item.live_uuid">（{{ item.start_at }}&nbsp;-&nbsp;{{ item.end_at }}）</div>
          <div class="left" v-else-if="item.video_uuid && item.video.cdn_resource.play_type == 'h5_hls'">（{{ item.video.duration }}）</div>
          <div class="left" v-else-if="item.video_uuid && item.video.cdn_resource.play_type == 'h5_hls_std'">（{{ item.video.duration }}）</div>
          <div class="left" v-else-if="item.experiment_uuid">（{{ item.experiment.duration }}课时）</div>
          <div class="right">
            <span v-if="item.live_uuid || item.face_uuid">{{ item.state }}</span>
            <span v-else-if="(item.video_uuid || item.authentication_uuid) && canStudy">{{ item.state }}</span>
            <span v-else-if="item.experiment_uuid">{{ item.state }}</span>
            <van-tag color="#fee7e8" text-color="#f74e52" size="mini" round v-if="item.video_uuid && item.video_index < video_trial_num && video_trial_time && video_trial_time > 0 && !canStudy">试看</van-tag>
            <div v-if="item.experiment_uuid && canStudy">
              <span v-if="item.experiment.progress.state == 'over' && item.experiment.state == '4' ">已学习</span>
              <span v-if="item.experiment.progress.state == 'running' && item.experiment.state == '4' ">学习中</span>
              <span v-if="item.experiment.progress == '' && item.experiment.state == '4' ">未学习</span>
              <span v-if="item.experiment.state != '4' ">暂未发布</span>
            </div>
          </div>
        </div>
      </dd>
    </dl>

    <!-- 试看 -->
    <van-popup v-model:show="watchModal.visible" :style="{ width: '100%', height: '40%', background: '#000' }" class="try_watch_modal">
      <div class="content" v-if="tryOver">
        <div class="layer">
          <div class="info">
            <p>试看结束，如需观看完整版请购买课程。</p>
            <div class="text-center" @click="refreshVideo">
              <span><van-icon name="replay" />重播</span>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 100%" v-else-if="watchModal.visible && watchModal.video">
        <VideoPlay :video_trial_time="video_trial_time" v-model:tryOver="tryOver" :canStudy="canStudy" :video="watchModal.video" :cur_uuid="curUuid" ref="video"></VideoPlay>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import VideoPlay from "components/course/VideoPlay"
  import { checkMessage} from 'api/promoter/selectPromo'
  import { checkLogin, getCurRecord } from "api/course/course/study"
  export default {
    props: {
      chapter: Array,
      video_trial_time: Number,
      video_trial_num: Number,
      canStudy: Boolean,
      curUuid: String,
      curType: String
    },
    components: {
      VideoPlay
    },
    data() {
      return {
        chapter_data: this.chapter,
        is_hover: this.canStudy, //true: 已报名，有hover效果， false：未报名，无hover效果
        watchModal: {
          visible: false,
          // media_id: '',
          // video_id: '',
          video: {},
        },
        tryOver: false,
        loginState: false,
      }
    },
    mounted() {
      if(this.chapter.length > 0){
        console.log(this.chapter)
        this.initChapter(this.chapter)
      }
      checkLogin().then(res => {
        if (res.code == 1) {
          this.loginState = false
        }
        else {
          this.loginState = true
        }
      })
    },
    methods: {
      initChapter(chapter){ console.log(chapter)
        let video_index = 0
        let now = dayjs(new Date()).format('YYYY-MM-DD HH:mm')
        let all_chapters = new Array()
        let live_end = new Array()
        for(let i=0; i<chapter.length; i++){
          this.chapter[i].showIntro = true
          this.chapter[i].chapter_content.forEach(item => {
            all_chapters.push(item)
            if(item.face_uuid){
              item.start_at = dayjs(item.face_teaching.start_at).format('MM-DD HH:mm')
              item.end_at = dayjs(item.face_teaching.end_at).format('MM-DD HH:mm')
              let position = JSON.parse(item.face_teaching.position)
              if(position[0].label.indexOf('市') >= 0 || position.length == 3){
                item.city = position[0].label
              }
              else {
                item.city = position[1].label
              }
              if(now < item.face_teaching.start_at){
                item.state = '未开始'
              }
              else if(now < item.face_teaching.end_at){
                item.state = '进行中'
              }
              else {
                item.state = '已结束'
              }
            }
            else if(item.live_uuid){
              item.start_at = dayjs(item.live.start_at).format('MM-DD HH:mm')
              item.end_at = dayjs(item.live.end_at).format('MM-DD HH:mm')
              if(now < dayjs(item.live.start_at).format('YYYY-MM-DD HH:mm')){
                item.state = '未开始'
              }
              else if(now < dayjs(item.live.end_at).format('YYYY-MM-DD HH:mm')){
                item.state = '进行中'
              }
              else {
                item.state = '已结束'
                live_end.push(item)
              }
            }
            else if(item.video_uuid){
              item.video_index = video_index ++
            }
          })
        }
        if(live_end.length == all_chapters.length && live_end.length > 0){
          this.$emit('curTypeChange', '直播回放')
        }
        this.chapter_data = chapter
        console.log(this.chapter_data)
        this.getStudyState()
      },
      goStudyHandler(item) {
        if(item.experiment_uuid) {
          return;
        }
        if(item.video_uuid && item.video_index < this.video_trial_num && this.video_trial_time && this.video_trial_time > 0 && !this.canStudy) {
          this.playVideo(item.video)
        } else {
          this.goStudyPage(item)
        }
      },
      playVideo(video) {
        if (!this.loginState) {
          this.$emit('login')
        }
        else {
          checkMessage().then((res) => {
          if(res.data == 0) {

            this.watchModal.visible = true
            this.tryOver = false
            this.watchModal.video = video

          }
          else {
              this.$emit('messageShow')
            }
          })
        }
      },
      refreshVideo() {
        this.tryOver = false
        this.$refs.video.prepareData(this.$refs.video.video)
      },
      goStudyPage(item) {
        checkMessage().then((res) => {
          if(res.data == 0) {
              if(item.face_uuid) {
                this.goStudy(item.face_uuid, 'face_teaching');
              } else if(item.live_uuid) {
                this.goStudy(item.live_uuid, 'live')
              } else if(item.video_uuid) {
                this.goStudy(item.video_uuid, 'video')
              } else if(item.authentication_uuid) {
                this.goStudy(item.authentication_uuid, 'authentication')
              }
          }else {
              this.$emit('messageShow')
            }
        })
      },
      goStudy(uuid, type) {
        if(this.canStudy){
          if (!this.loginState) {
            this.loginState = false
            this.$emit('login')
          }
          else {
            this.$router.push(`/mobile/course/detail/${type}/${this.curUuid}/${uuid}`)
          }
        }
      },
      getStudyState() {
        let data = {
          cur_uuid: this.curUuid
        }
        const that = this
        getCurRecord(data).then(res => {
          if(res.code === 0){
            let video_obj = {}
            let codes = []
            for(let i=0; i<res.video_records.length; i++){
              let record = res.video_records[i]
              if(record.is_finish || !(record.video_uuid in video_obj)){
                video_obj[record.video_uuid] = record.is_finish
              }
            }
            for(let i=0; i<res.codes.length; i++){
              codes.push(res.codes[i].authentication_uuid)
            }
            that.chapter_data.forEach(chapter => {
              chapter.chapter_content.forEach(item => {
                if(item.video_uuid){
                  if (item['video_uuid'] in video_obj){
                    item.state = video_obj[item['video_uuid']] == 1 ? '已学习' : '学习中'
                  }
                  else {
                    item.state = '未学习'
                  }
                }
                if(item.authentication_uuid){
                  if(codes.indexOf(item.authentication_uuid) >= 0){
                    item.state = '已获取'
                  }
                  else {
                    item.state = '发放中'
                  }
                }
                if(item.experiment_uuid){
                  if(item.state == 'running'){
                    item.state = '学习中'
                  }
                  else if (item.state == 'over'){
                    item.state = '已学习'
                  }
                  else if (item.state == ''){
                    item.state = '未学习'
                  }else if (item.state == 'null'){
                      item.state = '暂未发布'
                  }
              }
              })
            })
          }
        })
      },
      handleClose(){
        if(!this.tryOver){
          this.$refs.video.destoryVideoPlayer()
        }
        this.watchModal.video = null
        this.watchModal.visible = false
      },
    },
    watch: {
      'chapter': function (val){
        this.initChapter(val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .chapter_list {
    margin:0;
    > .intro {
      padding:10px;
      background:#fff;
      border:1px solid #f8f8f9;
    }
    dt {
      background:#f8f8f9;
      font-weight: bold;
      color:#333;
      font-size:16px;
      padding:10px;
      display: flex;
      > span {
        flex:1;
      }
    }
    dd {
      margin:0;
      padding:10px;
      line-height:1.5;
      border-bottom:1px solid #f1f1f1;
      .top {
        color:#333;
        margin-bottom:5px;
        > i {
          color:#777;
          font-size:18px;
          margin-right:5px;
          position: relative;
          top: 2px;
        }
      }
      .bottom {
        display:flex;
        align-items: center;
        font-size:12px;
        .right {
          flex:1;
          text-align: right;
          .van-tag {
            padding: 2px 10px;
          }
        }
      }
    }
  }
  .try_watch_modal {
    .content {
      height:100%;
      background:#000;
      position:relative;
    }
    .layer {
      position:absolute;
      top:0;
      right:0;
      bottom:0;
      left:0;
      background:rgba(0,0,0,0.5);
      .info {
        padding-top:24%;
        text-align:center;
        color:#fff;
        .van-icon {
          margin-right:5px;
        }
      }

    }
  }
</style>
